export const i18nRoot = "media_player.settings";
export const formId = "media-settings-form";

export const maxChapterCount = 100;
export const maxChapterTitleLength = 50;
